export const GET_MULTIPLE_JURISDICTIONS_LIST = "GET_MULTIPLE_JURISDICTIONS_LIST"
export const GET_MULTIPLE_JURISDICTIONS_LIST_SUCCESS = "GET_MULTIPLE_JURISDICTIONS_LIST_SUCCESS"
export const CHANGE_MULTIPLE_JURISDICTIONS_LIST = "CHANGE_MULTIPLE_JURISDICTIONS_LIST"